import { Button } from "@mantine/core";
import { quickPrompts } from "../utils/consts";

export type EmailQuickPrompt = { label: string; prompt: string };

interface EmailPromptBubblesProps {
  onPromptClick: (prompt: string, promptLabel: string) => void | Promise<void>;
  loadingPromptLabel: string | null;
  prompts?: EmailQuickPrompt[];
}

export const EmailPromptBubbles = ({
  onPromptClick,
  loadingPromptLabel,
  prompts = quickPrompts,
}: EmailPromptBubblesProps) => {
  const isAnyLoading = loadingPromptLabel !== null;

  return (
    <div className="flex flex-row gap-2 flex-wrap">
      {prompts.map((quickPrompt) => {
        const isThisLoading = loadingPromptLabel === quickPrompt.label;
        return (
          <Button
            key={quickPrompt.label}
            variant="light"
            radius="xl"
            size="sm"
            onClick={() => onPromptClick(quickPrompt.prompt, quickPrompt.label)}
            disabled={isAnyLoading}
            loading={isThisLoading}
          >
            {quickPrompt.label}
          </Button>
        );
      })}
    </div>
  );
};
